<template>
  <div>
    <div class="managementvideo">
      <div class="header_tabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="全部视频" name="9"></el-tab-pane>
          <el-tab-pane label="已发布" name="1"></el-tab-pane>
          <el-tab-pane label="审核中" name="0"></el-tab-pane>
          <el-tab-pane label="未通过" name="-1"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="manlistvideo" v-if="videotypeList.length > 0 ">
        <div class="itemvideo u-flex" v-if="item.videoInfo && item.videoInfo.flag ==0 " v-for="(item,index) in videotypeList" :key="index">
          <div class="cntvideoimg" v-if="item.videoInfo">
            <div class="tabstatus"
              :class="{'pass':item.videoInfo.videoState==1,'awit':item.videoInfo.videoState==0,'error':item.videoInfo.videoState ==-1}">
              {{item.videoInfo.videoState==1?'已通过':item.videoInfo.videoState==0?'审核中':'未通过'}}
            </div>
            <div class="vtimestatus">
              {{fifDate(item.videoInfo.videoDuration)}}
            </div>
            <div class="players">
              <img src="/static/center/player.png" alt="" srcset="">
            </div>
            <img style="width: 166px;height: 200px;border-radius: 8px;background-color: darkgrey;"
              :src="imgsrc +  item.videoInfo.coverImg" alt="" srcset="">
          </div>
          <div class="cntright" v-if="item.videoInfo">
            <div class="myfontexp">
               <input :id="item.videoInfo.videoId +'exp'" class="exp"  type="checkbox">
                   <div class="text">
                       <label class="btn" :for="item.videoInfo.videoId +'exp'"></label>
                       {{item.videoInfo.videoContent}}
                   </div>
            </div>
            <div class="status_look u-flex" v-if="item.videoInfo.videoState !== -1">
              <div class="statusvalue">
                <img src="/static/center/yanjing.png" alt="" srcset="">
                <span>{{item.videoExtra.playNum}}</span>
              </div>
              <div class="statusvalue">
                <img src="/static/center/pinglun.png" alt="" srcset="">
                <span>{{item.videoExtra.commentNum}}</span>
              </div>
              <div class="statusvalue">
                <img src="/static/center/guanzhu.png" alt="" srcset="">
                <span>{{item.videoExtra.likeNum}}</span>
              </div>
            </div>
            <div class="videoupdatetime">
              {{fifTime(item.videoInfo.publishTime)}}
            </div>
            <div class="videoerr myfontwidth1" v-if="item.videoInfo.videoState == -1">
              审批拒绝原因：{{item.videoCheck.refuseReason}}
            </div>
            <div class="videoerrbtn u-flex u-flex-items-center u-flex-center" @click="navrouter(item)"
              v-if="item.videoInfo.videoState == -1">
              <img src="/static/center/edit.png" style="margin-right: 4px;" alt="" srcset=""> 重新编辑
            </div>
            <div class="delvideo  u-flex u-flex-items-end u-flex-start" @click="delvideo(item.videoInfo.videoId)">
              <img src="/static/center/del.png" style="margin-right: 4px;" alt="" srcset=""> 删除作品
            </div>
          </div>
        </div>
      </div>
      <div v-else class="emitdata">
          <img  style="width: 300px;height: 150px;" src="/static/person/buy_emit.png" alt="">
          <div class="eemit_txt">
              暂无视频数据
          </div>
      </div>
    </div>
  </div>

</template>

<script>
  import ROOTURLS from '@/api/lz.js'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format';
  momentDurationFormatSetup(moment);
  import {
    videoDraftlist,
    videoDraftdelete,
    publishList,
    videodel
  } from '@/api/video.js'
  export default {
    data() {
      return {
        imgsrc:'',
        activeName: '9',
        videostatus: 3,
        videotypeList: []
      }
    },
    watch: {
      activeName(val) {
        console.log('切换了', val);
        this.initData(val);
      }
    },
    created(val) {
      this.initData('');
      this.imgsrc = ROOTURLS.ImgpagaUrl
      this.videotypeList.map(item => {
        if (item) {
          item.samllContent = item.content.substring(0, 92) + '···'
          item.showtxt = false
        }
      })
    },
    methods: {
      fifDate(time) {
        return moment.duration(time, 'seconds').format('mm:ss', {
          trim: false
        })
      },
      // 过滤时间
      fifTime(time) {
        if (time)
          return moment.unix(time).format('YYYY年MM月DD日 HH:mm')
      },
      initData(val) {
        if (val == 9) {
          val = ''
        }
        // 视频管理
        publishList({
          videoState: val,
          page: 1,
          limit: 100,
        }).then(res => {
          if (res.data.code == 200) {
            let arrlist = res.data.data.list;
            this.videotypeList = arrlist.map(item => {
              if (item.videoInfo && item.videoInfo.flag == 0) {
                item.videoInfo.samllContent = item.videoInfo.videoContent.substring(0, 92) + '···'
                item.videoInfo.showtxt = false
              }
              return item
            })
            console.log('列表', this.videotypeList);
          }
        })
      },
      // 展开
      showLangtxt(item) {
        item.showtxt = !item.showtxt;
        console.log('展开了吗');
      },
      // 删除视频
      delvideo(id) {

        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         console.log('删除成功');
         videodel({
           videoId: id
         }).then(res => {
           if (res.data.code == 200) {
             this.$message.success('删除成功');
             this.initData(this.activeName)
           }
         })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      // 编辑视频
      navrouter(item) {
        localStorage.setItem('editVideInfo',JSON.stringify(item))
        this.$emit('editvideo',item.videoInfo.videoId)
      },
      handleClick(tab, ) {
        console.log(tab, );
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';
  .emitdata{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-height: 30vh;
    flex-direction: column;
    .eemit_txt{
      margin-top: 18px;
      font-size: 16px;
      color: #666;
    }
  }
  .managementvideo {
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    width: calc(1200px - 202px);
    box-sizing: border-box;
    height: calc(100vh - 130px);
    overflow-y: scroll;

    /deep/ .el-tabs {
      .el-tabs__active-bar {
        background-color: #721EDC;
      }

      .is-active {
        color: #721EDC !important;
      }

      .el-tabs__item:hover {
        color: #721EDC !important;
      }
    }

    .delvideo {
      margin-top: 2%;
      cursor: pointer;
      opacity: 0;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ED1010;

      img {
        width: 16px;
        height: 16px;
      }
    }

    .itemvideo:hover {
      .delvideo {
        opacity: 1;
      }
    }

    .manlistvideo {
      padding: 0 24px;

      .itemvideo {
        margin-bottom: 24px;

        .cntright {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 12px 0;
          // box-shadow: 20px 20px 60px #bebebe,
          //   -20px -20px 60px #ffffff;
          .myfontexp{
            display: flex;
            overflow: hidden;
            .wrapper {
              display: flex;
              margin: 50px auto;
              width: 800px;
              overflow: hidden;
            /*   resize: horizontal; */
              border-radius: 8px;
              padding: 15px ;
            }
            .text {
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: justify;
              white-space: normal;
              word-break: break-all;
              word-wrap: break-word;
              /* display: flex; */
            /*   display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical; */
              position: relative;
              line-height: 1.38rem;
              max-height:3.02rem;
              color: #333;
              transition: .3s max-height;
            }
            .text::before {
              content: '';
              height: calc(100% - 26px);
              float: right;
            }
            .text::after {
              content: '';
              width: 999vw;
              height: 999vw;
              position: absolute;
              box-shadow: inset calc(100px - 999vw) calc(30px - 999vw) 0 0 #fff;
                margin-left: -100px;
            }
            .btn{
              position: relative;
              float: right;
              clear: both;
              margin-left: 20px;
              font-size: 14px;
              padding: 0 8px;
              // background: #3F51B5;
              line-height: 24px;
              border-radius: 4px;
              color:  #333;
              cursor: pointer;
              /* margin-top: -30px; */
            }
            .btn::after{
              content:'展开'
            }
            .exp{
              display: none;
            }
            .exp:checked+.text{
              max-height: none;
            }
            .exp:checked+.text::after{
              visibility: hidden;
            }
            .exp:checked+.text .btn::before{
              visibility: hidden;
            }
            .exp:checked+.text .btn::after{
              content:'收起'
            }
            .btn::before{
              content: '...';
              position: absolute;
              left: -5px;
              color: #333;
              transform: translateX(-100%)
            }
          }
          .videoerrbtn {
            margin-top: 2%;
            width: 98px;
            cursor: pointer;
            height: 36px;
            background: #721EDC;
            border-radius: 4px;
            text-align: center;
            line-height: 34px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;

            img {
              width: 16px;
              height: 16px;
            }
          }

          .videoerr {
            margin-top: 12px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ED1010;
          }

          .videoupdatetime {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }

          .status_look {
            margin: 30px 0 10px;

            .statusvalue {
              margin-right: 22px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;

              img {
                margin-right: 2px;
                width: 13px;
                height: 12px;
              }
            }
          }
          .vtitle {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
             overflow: hidden;
             text-overflow: ellipsis;
             text-align: justify;
             white-space: normal;
             word-break: break-all;
             word-wrap: break-word;
             position: relative;
             line-height: 1.5;
             max-height: 4.5em; /** 需要设置 **/
             transition: .3s max-height;
            .showtxt {
              position: absolute;
              right: 4px;
              bottom: -3px;

            }
          }
        }

        .cntvideoimg {
          position: relative;
          margin-right: 12px;
          width: 166px;height: 200px;border-radius: 8px;
          .pass {
            background-color: #7FE14D;
          }

          .awit {
            background-color: #1076E9;
          }

          .error {
            background-color: #ED1010;
          }

          .tabstatus {
            position: absolute;
            top: 12px;
            border-radius: 0 15px 15px 0;
            left: 0;
            width: 52px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
          }

          .players {
            position: absolute;
            top: 50%;
            left: 50%;
            color: #FFFFFF;
            transform: translate(-50%, -50%);
            font-size: 12px;

            img {
              width: 40px;
              height: 40px
            }

            ;
          }

          .vtimestatus {
            position: absolute;
            bottom: 6px;
            right: 8px;
            color: #FFFFFF;
            font-size: 12px;
          }
        }

      }
    }

    .header_tabs {
      padding: 14px 24px;


    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/template/videomanagement.vue